import { ICarrierContact } from 'types'
import * as yup from 'yup'

export const ContactInfoTypeSchema = yup.object({
  id: yup.string(),
  contactEmail: yup.string().nullable().required(),
  contactPhone: yup.string().nullable(),
  contactPhoneExt: yup.string().nullable(),
  address: yup.string().max(50).nullable().required(),
  addressLine2: yup.string().nullable(),
  countryCode: yup.string().nullable().required(),
  city: yup.string().nullable().required(),
  stateCode: yup.string().nullable().required(),
  zipcode: yup.string().nullable().required(),
})

/**
 * This function transform a TContactInfoTypeSchema to a ICarrierContact
 * @param data TContactInfoTypeSchema variable
 * @returns ICarrierContact
 */
export const mapContactInfoToCarrierContact = (data: TContactInfoTypeSchema): ICarrierContact => ({
  contactEmail: data.contactEmail || '',
  location: {
    id: data.id,
    contactPhone: data.contactPhone || '',
    contactPhoneExt: data.contactPhoneExt || '',
    address: data.address || '',
    addressLine2: data.addressLine2 || '',
    countryCode: data.countryCode || '',
    city: data.city || '',
    stateCode: data.stateCode || '',
    zipcode: data.zipcode || '',
  },
})

export type TContactInfoTypeSchema = yup.InferType<typeof ContactInfoTypeSchema>
